import { Component } from '@angular/core';





@Component({
	selector: 'grid-dropdown-editor',
	template: `
    <label *ngIf="showInput" style="margin-bottom:0;">{{labelValue}}  </label>
    <select class="grid-cell-edit-layout" *ngIf="!showInput" (change)="updatedData()"
 		[(ngModel)]="selectedID" >
    	<option [ngValue]="item.id"  *ngFor="let item of commonList"  >{{item.value}}</option>
	</select>
    `,
	styles: [
		`.grid-cell-edit-layout{
			margin-left: 1%;
			width: 96%;
			min-width: 100px;
			height: 26px;}`
	],
	standalone: false
})

export class GridDropdownEditorComponent {
	public params: any;
	showInput = true;
	selectedID = '';
	commonList = []
	labelValue: any;
	local_str_name = "PCS-base-dropdown-items"

	constructor() { }

	agInit(params: any): void {
		this.params = params;

		switch (params.column) {
			case 'dsReqNeededCOL':
				this.initDsReqNeeded();
				break;

			case 'dsWoReqSuppliersCOL':
				this.initDsWoReqSuppliers();
				break;

			case 'plantCOL':
				this.initPlant();
				break;

			case 'lmCOL':
				this.initLm();
				break;

			case 'diagramCOL':
				this.initDiagram();
				break;

			case 'sketchCOL':
				this.initSketch();
				break;

			case 'dockCOL':
				this.initDock();
				break;

			default:
				break;
		}

		this.updateShowInput(params);
	}

	private updateShowInput(params: any): void {
		if (params.data?.rowCheckBox) {
			this.showInput = false;
		} else {
			this.showInput = true;
		}

		if (params?.isWriteAccess == false) {  // NOSONAR
			this.showInput = true;
		}
	}

	private initDsReqNeeded(): void {
		this.commonList = JSON.parse(localStorage.getItem(this.local_str_name)).dsReqNeed;
		this.params.data.dsReqNeededCOL = this;

		const selected = this.commonList.find(
			x => x.id == this.params.data.dsReqNeeded  // NOSONAR
		);

		if (selected) {
			this.selectedID = selected.id;
			this.labelValue = selected.value;
		}
	}

	private initDsWoReqSuppliers(): void {
		this.commonList = JSON.parse(localStorage.getItem(this.local_str_name))
			.dsWithoutReqSuppliers;

		this.params.data.dsWoReqSuppliersCOL = this;

		const selected = this.commonList.find(
			x => x.id == this.params.data.dsWoReqSuppliers  // NOSONAR
		);

		if (selected) {
			this.selectedID = selected.id;
			this.labelValue = selected.value;
		}
	}

	private initPlant(): void {
		this.commonList = [];

		const tempList = JSON.parse(
			localStorage.getItem(this.local_str_name)
		).plantDockList;

		tempList.forEach((obj, index) => {
			if (obj.plant != null) { // NOSONAR
				this.commonList.push({ id: index + 1, value: obj.plant });
			}
		});

		this.commonList = [
			...new Map(this.commonList.map(x => [x.value, x])).values()
		];

		this.params.data.plantCOL = this;
		this.labelValue = this.params.data.plant;

		const selected = this.commonList.find(x => x.value == this.labelValue); // NOSONAR
		if (selected) {
			this.selectedID = selected.id;
		}
	}

	private initLm(): void {
		this.initLmDiagramSketch('lm', 'lmCOL');
	}

	private initDiagram(): void {
		this.initLmDiagramSketch('diagram', 'diagramCOL');
	}

	private initSketch(): void {
		this.initLmDiagramSketch('sketch', 'sketchCOL');
	}

	private initLmDiagramSketch(field: string, columnKey: string): void {
		this.commonList = JSON.parse(
			localStorage.getItem(this.local_str_name)
		).lmDiagramSketch;

		this.params.data[columnKey] = this;
		this.labelValue = this.params.data[field];

		const selected = this.commonList.find(x => x.value == this.labelValue); // NOSONAR
		if (selected) {
			this.selectedID = selected.id;
		}
	}

	private initDock(): void {
		this.commonList = [];

		let tempList = JSON.parse(
			localStorage.getItem(this.local_str_name)
		).plantDockList;

		if (tempList.length) {
			tempList = tempList.filter(x => x.plant == this.params.data.plant); // NOSONAR

			tempList.forEach((obj, index) => {
				if (obj.dock != null) { // NOSONAR
					this.commonList.push({ id: index + 1, value: obj.dock });
				}
			});
		}

		this.commonList = [
			...new Map(this.commonList.map(x => [x.value, x])).values()
		];

		this.params.data.dockCOL = this;
		this.labelValue = this.params.data.dock;

		const selected = this.commonList.find(x => x.value == this.labelValue); // NOSONAR
		if (selected) {
			this.selectedID = selected.id;
		}
	}









	// called when the cell is refreshed
	refresh(params: any): boolean {
		this.params = params;
		return true;
	}



	updatedData(): void {
		const selectedItem = this.commonList.find(x => x.id == this.selectedID);  // NOSONAR
		if (!selectedItem) {
			return;
		}

		this.labelValue = selectedItem.value;

		switch (this.params.column) {
			case 'dsReqNeededCOL':
				this.params.data.dsReqNeeded = selectedItem.id;
				return;

			case 'dsWoReqSuppliersCOL':
				this.params.data.dsWoReqSuppliers = selectedItem.id;
				return;

			case 'dockCOL':
				this.params.data.dock = this.labelValue;
				return;

			case 'sketchCOL':
				this.params.data.sketch = this.labelValue;
				return;

			case 'lmCOL':
				this.params.data.lm = this.labelValue;
				return;

			case 'diagramCOL':
				this.params.data.diagram = this.labelValue;
				return;

			case 'plantCOL':
				this.handlePlantDockUpdate();
				return;

			default:
				return;
		}
	}
	private handlePlantDockUpdate(): void {
		this.params.data.plant = this.labelValue;

		const storage = localStorage.getItem('PCS-base-dropdown-items');
		if (!storage) {
			return;
		}

		const plantDockList = JSON.parse(storage).plantDockList || [];
		if (!plantDockList.length) {
			return;
		}

		const filteredDocks = plantDockList
			.filter(x => x.plant == this.params.data.plant && x.dock)  // NOSONAR
			.map((x, index) => ({ id: index + 1, value: x.dock }));

		const uniqueDocks: any = [
			...new Map(filteredDocks.map(x => [x.value, x])).values()
		];

		if (!uniqueDocks.length) {
			return;
		}

		const dockCOL = this.params.data.dockCOL;
		dockCOL.commonList = uniqueDocks;

		const selectedDock = uniqueDocks.find(x => x.value == this.params.data.dock) || uniqueDocks[0]; // NOSONAR

		dockCOL.selectedID = selectedDock.id;
		dockCOL.labelValue = selectedDock.value;
		this.params.data.dock = selectedDock.value;
	}


}
